module.exports = __webpack_public_path__ + "img/multi-media-podcast-icon.1546dc6b.png";